import React, { useState , useContext} from 'react';
import { Bell, User, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../authContext/context';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
} from '@mui/material';

import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';

import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
function Header() {
  
    const authCtx = useContext(AuthContext);
    console.log(authCtx , 'AUTHCTX')

  const handleLogout = () => {
    console.log('logout')
     authCtx.Logout()
   
  };

  const handleClose = () => {
       console.log('HandleClose')
  };
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/'); // 👈 navigates to /about
  };

 
  return (
    <AppBar position="static" sx={{ backgroundColor: '#212529' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* App Name */}
      <Typography
  variant="h6"
  fontWeight="bold"
  component={Link}
  to="/"
  sx={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
>
  Universal
</Typography>

        {/* Right Side */}

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton color="inherit">
            <Bell size={20} />
          </IconButton>
          <Dropdown className='mb-0'>
      <Dropdown.Toggle className="red-bg border-0" id="dropdown-basic">
        A
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item><NavLink to="/account/manage"> <User size={16} style={{ marginRight: 8 }} /> Profile</NavLink></Dropdown.Item>
        <Dropdown.Item onClick={handleLogout}><LogOut size={16} style={{ marginRight: 8 }}/> Logout</Dropdown.Item>
        
      </Dropdown.Menu>
    </Dropdown>

          
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;